import { render } from "./B2bTableAuditoriaDocumentos.vue?vue&type=template&id=43ca75c7&scoped=true&lang=pug"
import script from "./B2bTableAuditoriaDocumentos.vue?vue&type=script&lang=js"
export * from "./B2bTableAuditoriaDocumentos.vue?vue&type=script&lang=js"

import "./B2bTableAuditoriaDocumentos.vue?vue&type=style&index=0&id=43ca75c7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43ca75c7"]])

export default __exports__